// extracted by mini-css-extract-plugin
module.exports = {"noData":"NoData_noData__GN_pN","iconWrapper":"NoData_iconWrapper__3nDM_"};